import React, { useEffect, useState } from "react";
import helpIcon from "../../../../../assets/disabilityIcons/IC_Help.svg";
import addIcon from "../../../../../assets/disabilityIcons/Frame 427319007.svg";
import MenuIcon from "../../../../../assets/disabilityIcons/Menu.svg";
import CustomModal from "../../../../../components/styled-components/modal/custom-modal/custom-modal";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import { MODULE_API } from "../../../../../apis";
import { Table } from "antd";
import moment from "moment";
import swal from "sweetalert";
import axios from "axios";
import { ToolTipCreator } from "../../../../../helpers/ToolTipCreator";

export default function EquipmentNeed() {
  const [subModulefields, setSubModuleFields] = useState(null);
  const [moduleName, setModuleName] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [formData, setFormData] = useState({});
  const [dropdown, setDropdown] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [modalTitle, setModalTitle] = useState("");

  const [tableData, setTableData] = useState({
    medicalEquipmentData: [],
    mobilityAidsData: [],
    communicationDevicesData: [],
    adaptiveTechnologyData: [],
  });

  const showModal = async (moduleName) => {
    setLoading(true);
    setModalTitle(moduleName);
    setModuleName(moduleName);
    setIsModalVisible(true);
    setSubModuleFields(null);
    await getSubModuleAttributes(moduleName);
  };
  const viewModal = async (record) => {
    if (!record) return;
    setFormData(record);
    setIsModalVisible(true);
    setModalTitle("View Item");
    setSubModuleFields(null);
    await getSubModuleAttributes(record.module);
  };
  const updateModal = async (record) => {
    if (!record) return;
    setFormData(record);
    setIsModalVisible(true);
    setModalTitle("Update");
    setSubModuleFields(null);
    await getSubModuleAttributes(record.module);
  };
  const getSubModuleAttributes = async (submod) => {
    try {
      setLoading(true);
      const res = await MODULE_API.fetchAttributes(submod);
      if (res && res.attributes) {
        setSubModuleFields(res);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching attributes", error);
    }
  };
  const handleCreate = async () => {
    try {
      setLoading(true);
      await MODULE_API.addAsset(moduleName, {
        clientModules: [formData],
      });
      const res = await fetchData(moduleName);
      setTableData((prev) => ({
        ...prev,
        [formatModuleKey(moduleName)]: res && res.records ? res.records : [],
      }));
      setLoading(false);
      setFormData(null);
    } catch (error) {
      console.log(error);
    } finally {
      setFormData(null);
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleImageUpload = async (event) => {
    console.log("e.target", event.target);
    const fileSize = event.target.files[0].size / (1024 * 1000); // in MB
    console.log("fileSize in mb", fileSize);
    let uploadFile = event.target.files[0];
    if (uploadFile) {
      const formData = new FormData();
      formData.append("file", uploadFile);
      const name = uploadFile.name;
      const lastDot = name.lastIndexOf(".");
      const fileName = name.substring(0, lastDot);
      const ext = name.substring(lastDot + 1);
      setLoading(true);
      const resdata = await MODULE_API.uploadFile({
        fileExt: ext,
        contentType: uploadFile.type,
      });
      const resupload = await axios.put(resdata.uploadUrl, uploadFile, {
        headers: { "Content-type": uploadFile.type },
      });
      const res = resdata.uploadUrl.split("?")[0];
      console.log("image", res);
      setLoading(false);
      setFormData((prev) => ({
        ...prev,
        ["Document Upload"]: res,
        ["Uploaded File Name"]:name,
      }));
    }
  };
  const handleSubmit = async (body) => {
    console.log("Submit...", body);
    try {
      setLoading(true);
      const response = await MODULE_API.addAsset(moduleName, {
        clientModules: [body],
      });
      console.log("resposnse Upload", response);
      if (response && response.message) {
        swal("Success!", response.message, "success");
      }
      const res = await fetchData(moduleName);
      setTableData((prev) => ({
        ...prev,
        [formatModuleKey(moduleName)]: (res && res.records) || [],
      }));
      setLoading(false);
    } catch (error) {
      console.log("error in update", error);
      setLoading(false);
    }
  };

  const handelCloseModal = () => {
    setIsModalVisible(false);
    setFormData(null);
  };
  const handleItemsInfoSelect = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const getSelectedRow = (id) => {
    setSelectedIndex(id);
  };
  const deleteRecord = async (record) => {
    console.log("record", record);
    try {
      setLoading(true);
      await MODULE_API.deleteItem({
        clientModules: [record.id],
      });
      const res = await fetchData(record.module);
      setTableData((prev) => ({
        ...prev,
        [formatModuleKey(record.module)]: res && res.records ? res.records : [],
      }));
      setLoading(false);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  const updateRecord = async () => {
    try {
      setLoading(true);
      await MODULE_API.updateClientModule(formData.id, {
        ...formData,
      });
      const res = await fetchData(formData.module);
      setTableData((prev) => ({
        ...prev,
        [formatModuleKey(formData.module)]:
          res && res.records ? res.records : [],
      }));
      setLoading(false);
    } catch (error) {
    } finally {
      setLoading(false);
      setFormData(null);
    }
  };
  const moduleNames = [
    "Medical Equipment",
    "Mobility Aids",
    "Communication Device",
    "Adaptive Technology",
  ];
  const fetchAllModulesData = async () => {
    setLoading(true);
    try {
      const results = await Promise.all(
        moduleNames.map((name) => fetchData(name))
      );
      console.log("All module results:", results);
      const tableDataObj = results.reduce((acc, { moduleName, records }) => {
        acc[formatModuleKey(moduleName)] = records;
        return acc;
      }, {});

      setTableData(tableDataObj);
    } catch (error) {
      console.error("Error fetching all modules:", error);
    } finally {
      setLoading(false);
    }
  };
  const fetchData = async (moduleName) => {
    try {
      const res = await MODULE_API.fetchItems({
        moduleName,
        pageNum: 1,
        limit: 10,
        body: {},
      });
      const records = res.records || [];
      return { moduleName, records }; // Return object with moduleName to map later
    } catch (error) {
      console.error(`Error fetching data for ${moduleName}:`, error);
      return { moduleName, records: [] }; // Return empty if failed
    }
  };
  const formatModuleKey = (moduleName) => {
    return (
      moduleName &&
      moduleName
        .replace(/[^a-zA-Z ]/g, "") // Remove special chars
        .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) =>
          index === 0 ? word.toLowerCase() : word.toUpperCase()
        )
        .replace(/\s+/g, "") + "Data"
    );
  };
  useEffect(() => {
    fetchAllModulesData();
  }, []);
  console.log("tableData", tableData);
  const extractFileNameFromUrl = (url) => {
    const urlParts = url.split("/");
    return urlParts[urlParts.length - 1]; // Get the last part of the URL, which is the file name
  };
  const medicalEquipmentColsData = [
    {
      title: "Medical Equipment",
      dataIndex: "Medical Equipment",
      key: "medicalEquipment",
      render: (text) => text || "N/A",
    },
    {
      title: "Maintenance Schedule",
      dataIndex: "Maintenance Schedule",
      key: "mantainanceSchedule",
      render: (dataString) => moment(dataString).format("MM-DD-YYYY") || "N/A",
    },
    {
      title: "Replacement Schedule",
      dataIndex: "Replacement Schedule",
      key: "replacementSchedule",
      render: (dataString) => moment(dataString).format("MM-DD-YYYY") || "N/A",
    },
    {
      title: "Uploaded Documents",
      dataIndex: "Document Upload",
      key: "Document Upload",
      render: (fileName, record) => {
        return record["Document Upload"] ? (
          <div style={{ display: "flex", alignItems: "center" }}>
            {" "}
            <a
              style={{ color: "#7d8fb3" }}
              href={record["Document Upload"]}
              target="blank">
              {" "}
              {record["Uploaded File Name"] || extractFileNameFromUrl(record["Document Upload"])}
            </a>
          </div>
        ) : (
          "N/A"
        );
      },
    },
    {
      title: "Action",
      key: "action",
      render: (record, index) => (
        <React.Fragment>
          <div style={{ display: "flex" }} key={index}>
            {" "}
            <div
              onClick={() => {
                getSelectedRow(record.id);
                setDropdown(!dropdown);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "6px 16px",
                width: "5px",
              }}
            >
              <img
                src={MenuIcon}
                style={{ rotate: "90deg" }}
                alt="menuIcon"
              ></img>{" "}
            </div>
            {dropdown && selectedIndex === record.id && (
              <React.Fragment>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  className=""
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}
                ></div>

                <div className="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    <li
                      className="liHover"
                      onClick={() => {
                        setDropdown(false);
                        viewModal(record);
                      }}
                    >
                      View
                    </li>
                    <li
                      className="liHover"
                      // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                      onClick={() => {
                        setDropdown(false);
                        updateModal(record);
                      }}
                    >
                      Update
                    </li>

                    <li
                      className="liHover"
                      // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                      onClick={() => {
                        deleteRecord(record);
                        setDropdown(false);
                      }}
                    >
                      Delete
                    </li>
                  </ul>
                </div>
              </React.Fragment>
            )}
          </div>
        </React.Fragment>
      ),
    },
  ];
  const mobilityAidsColsData = [
    {
      title: "Mobility Aids",
      dataIndex: "Mobility Aids",
      key: "medicalEquipment",
      render: (text) => text || "N/A",
    },
    {
      title: "Maintenance Schedule",
      dataIndex: "Maintenance Schedule",
      key: "mantainanceSchedule",
      render: (dataString) => moment(dataString).format("MM-DD-YYYY") || "N/A",
    },
    {
      title: "Replacement Schedule",
      dataIndex: "Replacement Schedule",
      key: "replacementSchedule",
      render: (dataString) => moment(dataString).format("MM-DD-YYYY") || "N/A",
    },
    {
      title: "Uploaded Documents",
      dataIndex: "Document Upload",
      key: "uploadedDocuments",
      render: (text, record) => (
        <React.Fragment>
          {text ? extractFileNameFromUrl(text) : "N/A"}
        </React.Fragment>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (record, index) => (
        <React.Fragment>
          <div style={{ display: "flex" }} key={index}>
            {" "}
            <div
              onClick={() => {
                getSelectedRow(record.id);
                setDropdown(!dropdown);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "6px 16px",
                width: "5px",
              }}
            >
              <img
                src={MenuIcon}
                style={{ rotate: "90deg" }}
                alt="menuIcon"
              ></img>{" "}
            </div>
            {dropdown && selectedIndex === record.id && (
              <React.Fragment>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  className=""
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}
                ></div>

                <div className="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    <li
                      className="liHover"
                      onClick={() => {
                        setDropdown(false);
                        viewModal(record);
                      }}
                    >
                      View
                    </li>
                    <li
                      className="liHover"
                      // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                      onClick={() => {
                        setDropdown(false);
                        updateModal(record);
                      }}
                    >
                      Update
                    </li>

                    <li
                      className="liHover"
                      // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                      onClick={() => {
                        deleteRecord(record);
                        setDropdown(false);
                      }}
                    >
                      Delete
                    </li>
                  </ul>
                </div>
              </React.Fragment>
            )}
          </div>
        </React.Fragment>
      ),
    },
  ];
  const communicationDevicesColsData = [
    {
      title: "Communication Devices",
      dataIndex: "Communication Devices",
      key: "medicalEquipment",
    },
    {
      title: "Maintenance Schedule",
      dataIndex: "Mantainance Schedule",
      key: "mantainanceSchedule",
      render: (dataString) => moment(dataString).format("MM-DD-YYYY") || "N/A",
    },
    {
      title: "Replacement Schedule",
      dataIndex: "Replacement Schedule",
      key: "replacementSchedule",
      render: (dataString) => moment(dataString).format("MM-DD-YYYY") || "N/A",
    },
    {
      title: "Uploaded Documents",
      dataIndex: "Document Upload",
      key: "uploadedDocuments",
      render: (text, record) => (
        <React.Fragment>
          {text ? extractFileNameFromUrl(text) : "N/A"}
        </React.Fragment>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (record, index) => (
        <React.Fragment>
          <div style={{ display: "flex" }} key={index}>
            {" "}
            <div
              onClick={() => {
                getSelectedRow(record.id);
                setDropdown(!dropdown);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "6px 16px",
                width: "5px",
              }}
            >
              <img
                src={MenuIcon}
                style={{ rotate: "90deg" }}
                alt="menuIcon"
              ></img>{" "}
            </div>
            {dropdown && selectedIndex === record.id && (
              <React.Fragment>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  className=""
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}
                ></div>

                <div className="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    <li
                      className="liHover"
                      onClick={() => {
                        setDropdown(false);
                        viewModal(record);
                      }}
                    >
                      View
                    </li>
                    <li
                      className="liHover"
                      // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                      onClick={() => {
                        setDropdown(false);
                        updateModal(record);
                      }}
                    >
                      Update
                    </li>

                    <li
                      className="liHover"
                      // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                      onClick={() => {
                        deleteRecord(record);
                        setDropdown(false);
                      }}
                    >
                      Delete
                    </li>
                  </ul>
                </div>
              </React.Fragment>
            )}
          </div>
        </React.Fragment>
      ),
    },
  ];
  const adaptiveTechColsData = [
    {
      title: "Adaptive Technology",
      dataIndex: "Adaptive Technology",
      key: "medicalEquipment",
      render: (text) => text || "N/A",
    },
    {
      title: "Maintenance Schedule",
      dataIndex: "Mantainance Schedule",
      key: "mantainanceSchedule",
      render: (dataString) => moment(dataString).format("MM-DD-YYYY") || "N/A",
    },
    {
      title: "Replacement Schedule",
      dataIndex: "Replacement Schedule",
      key: "replacementSchedule",
      render: (dataString) => moment(dataString).format("MM-DD-YYYY") || "N/A",
    },
    {
      title: "Uploaded Documents",
      dataIndex: "Document Upload",
      key: "uploadedDocuments",
      render: (text, record) => (
        <React.Fragment>
          {text ? extractFileNameFromUrl(text) : "N/A"}
        </React.Fragment>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (record, index) => (
        <React.Fragment>
          <div style={{ display: "flex" }} key={index}>
            {" "}
            <div
              onClick={() => {
                getSelectedRow(record.id);
                setDropdown(!dropdown);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "6px 16px",
                width: "5px",
              }}
            >
              <img
                src={MenuIcon}
                style={{ rotate: "90deg" }}
                alt="menuIcon"
              ></img>{" "}
            </div>
            {dropdown && selectedIndex === record.id && (
              <React.Fragment>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  className=""
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}
                ></div>

                <div className="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    <li
                      className="liHover"
                      onClick={() => {
                        setDropdown(false);
                        viewModal(record);
                      }}
                    >
                      View
                    </li>
                    <li
                      className="liHover"
                      // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                      onClick={() => {
                        setDropdown(false);
                        updateModal(record);
                      }}
                    >
                      Update
                    </li>

                    <li
                      className="liHover"
                      // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                      onClick={() => {
                        deleteRecord(record);
                        setDropdown(false);
                      }}
                    >
                      Delete
                    </li>
                  </ul>
                </div>
              </React.Fragment>
            )}
          </div>
        </React.Fragment>
      ),
    },
  ];

  console.log("tableData", tableData);
  return (
    <>
      <div>
        <CustomModal
          show={isModalVisible}
          fields={subModulefields && subModulefields}
          modalTitle={modalTitle}
          close={handelCloseModal}
          onChange={handleChange}
          onSelectChange={handleItemsInfoSelect}
          submitData={modalTitle !== "Update" ? handleCreate : updateRecord}
          selectedRowData={formData && formData}
          handleItemsInfoImageChange={handleImageUpload}
          loading={loading}
        />
      </div>
      <div className="primary-caregiver-container">
        <div className="legal-document-title-container">
        <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
          <h2 className="primary-caregiver-title">Equipment Needs</h2>
          <ToolTipCreator name={"Disability_Equipment_Needs"}/>
        </div>
        </div>
        {/* <div className="primary-caregiver-icon-container">
          <img src={helpIcon} alt="help" width="18.67px" height="18.67px" />
        </div> */}
      </div>
      <div className="primary-caregiver-box-container">
        <div className="primary-caregiver-header-container">
          <h3 className="primary-caregiver-box-title">Medical Equipment</h3>
          <div
            className="primary-caregiver-add-button-container"
            onClick={() => showModal("Medical Equipment")}
            style={{ cursor: "pointer" }}
          >
            <img src={addIcon} alt="" width={"24px"} height={"24px"} />
          </div>
        </div>
        <div className="primary-caregiver-table-container">
          <Table
            columns={medicalEquipmentColsData}
            dataSource={tableData.medicalEquipmentData}
          />
          <NewLoader isLoading={loading} />
        </div>
      </div>

      <div className="primary-caregiver-box-container">
        <div className="primary-caregiver-header-container">
          <h3 className="primary-caregiver-box-title">Mobility Aids</h3>
          <div
            className="primary-caregiver-add-button-container"
            onClick={() => showModal("Mobility Aids")}
            style={{ cursor: "pointer" }}
          >
            <img src={addIcon} alt="" width={"24px"} height={"24px"} />
          </div>
        </div>
        <div className="primary-caregiver-table-container">
          <Table
            columns={mobilityAidsColsData}
            dataSource={tableData.mobilityAidsData}
          />
          <NewLoader isLoading={loading} />
        </div>
      </div>
      <div className="primary-caregiver-box-container">
        <div className="primary-caregiver-header-container">
          <h3 className="primary-caregiver-box-title">Communication Devices</h3>
          <div
            className="primary-caregiver-add-button-container"
            onClick={() => showModal("Communication Devices")}
            style={{ cursor: "pointer" }}
          >
            <img src={addIcon} alt="" width={"24px"} height={"24px"} />
          </div>
        </div>
        <div className="primary-caregiver-table-container">
          <Table
            columns={communicationDevicesColsData}
            dataSource={tableData.communicationDevicesData}
          />
          <NewLoader isLoading={loading} />
        </div>
      </div>

      <div className="primary-caregiver-box-container">
        <div className="primary-caregiver-header-container">
          <h3 className="primary-caregiver-box-title">Adaptive Technology</h3>
          <div
            className="primary-caregiver-add-button-container"
            onClick={() => showModal("Adaptive Technology")}
            style={{ cursor: "pointer" }}
          >
            <img src={addIcon} alt="" width={"24px"} height={"24px"} />
          </div>
        </div>
        <div className="primary-caregiver-table-container">
          <Table
            columns={adaptiveTechColsData}
            dataSource={tableData.adaptiveTechnologyData}
          />
          <NewLoader isLoading={loading} />
        </div>
      </div>
    </>
  );
}
